<template>
  <el-card>
    <div slot="header" class="flex justify-between">
      <span>挂单信息</span>
      <el-button 
        type="warning" 
        style="float: right;" 
        @click="_back"
      >
        <i class="el-icon-close"></i> 返回
      </el-button>
    </div>
    
    <el-table
      :data="storeOrderUpManageInfo.storeOrderUps"
      border
      stripe
      style="width: 100%"
    >
      <el-table-column prop="orderUpId" label="订单编号" align="center"></el-table-column>
      <el-table-column prop="personName" label="用户名称" align="center"></el-table-column>
      <el-table-column prop="totalPrice" label="订单总价" align="center"></el-table-column>
      <el-table-column prop="stateName" label="订单状态" align="center"></el-table-column>
      <el-table-column prop="remark" label="订单备注" align="center"></el-table-column>
      <el-table-column prop="createTime" label="挂单时间" align="center"></el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button-group>
            <el-button 
              size="mini" 
              @click="_StoreOrderUp(scope.row)"
            >选择</el-button>
            <el-button 
              size="mini" 
              @click="_openDeleteStoreOrderUpModel(scope.row)"
            >删除</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="storeOrderUpManageInfo.conditions.page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="storeOrderUpManageInfo.conditions.row"
      layout="total, sizes, prev, pager, next, jumper"
      :total="storeOrderUpManageInfo.total"
      style="margin-top: 20px; text-align: right;"
    ></el-pagination>
    
    <delete-store-order-up 
      ref="deleteStoreOrderUp"
      @storeOrderUpDeleted="_lisStoreOrderUps"
    ></delete-store-order-up>
  </el-card>
</template>

<script>
import { queryStoreOrderUp } from '@/api/goods/storeOrderUpManageApi'
import DeleteStoreOrderUp from '@/components/goods/deleteStoreOrderUp/deleteStoreOrderUp'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'StoreOrderUpManage',
  components: {
    DeleteStoreOrderUp
  },
  data() {
    return {
      storeOrderUpManageInfo: {
        storeOrderUps: [],
        total: 0,
        records: 1,
        conditions: {
          shopId: getShopId(),
          page: 1,
          row: 10
        }
      }
    }
  },
  methods: {
    _lisStoreOrderUps(page = 1, rows = 10) {
      this.storeOrderUpManageInfo.conditions.page = page
      this.storeOrderUpManageInfo.conditions.row = rows
      
      queryStoreOrderUp(this.storeOrderUpManageInfo.conditions).then(res => {
        this.storeOrderUpManageInfo.total = res.total
        this.storeOrderUpManageInfo.records = res.records
        this.storeOrderUpManageInfo.storeOrderUps = res.data
      }).catch(err => {
        console.error('获取挂单列表失败:', err)
      })
    },
    
    _StoreOrderUp(storeOrderUp) {
      this.$emit('storeOrderUpSelected', storeOrderUp)
    },
    
    _openDeleteStoreOrderUpModel(storeOrderUp) {
      this.$refs.deleteStoreOrderUp.open(storeOrderUp)
    },
    
    _back() {
      this.$emit('back')
    },
    
    handleSizeChange(val) {
      this.storeOrderUpManageInfo.conditions.row = val
      this._lisStoreOrderUps()
    },
    
    handleCurrentChange(val) {
      this.storeOrderUpManageInfo.conditions.page = val
      this._lisStoreOrderUps()
    },
    
    listStoreOrderUp() {
      this._lisStoreOrderUps()
    }
  },
  created() {
    this._lisStoreOrderUps()
  }
}
</script>

<style scoped>
/* 可以添加自定义样式 */
</style>